var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendorEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 108,
    viewBox: "0 0 118 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4512 38.68C71.0812 38.68 62.5612 38.34 54.5912 36.12C46.7712 33.95 39.5912 29.74 33.1912 24.87C29.0012 21.7 25.1912 19.17 19.7512 19.55C14.4293 19.838 9.34 21.8253 5.23121 25.22C-1.68879 31.28 -0.648793 42.51 2.12121 50.37C6.28121 62.24 18.9412 70.51 29.7012 75.86C42.1312 82.07 55.7912 85.68 69.4812 87.75C81.4812 89.58 96.9012 90.9 107.301 83.07C116.851 75.86 119.471 59.42 117.131 48.32C116.563 45.0409 114.817 42.0821 112.221 40C105.511 35.09 95.5012 38.37 87.9612 38.53C85.1612 38.59 82.3112 38.66 79.4512 38.68Z",
    fill: "#3B0069",
    fillOpacity: 0.37
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3714 107.21C79.6458 107.21 96.0814 106.185 96.0814 104.92C96.0814 103.655 79.6458 102.63 59.3714 102.63C39.097 102.63 22.6614 103.655 22.6614 104.92C22.6614 106.185 39.097 107.21 59.3714 107.21Z",
    fill: "#3B0069",
    fillOpacity: 0.37
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57129 16.63L20.5713 15.53C22.1924 15.3881 23.813 15.8073 25.1619 16.7175C26.5109 17.6277 27.5062 18.9736 27.9813 20.53L40.4413 62.23L38.0013 66.6C37.3746 67.726 37.0652 69.0009 37.1061 70.2889C37.147 71.5769 37.5368 72.8296 38.2337 73.9135C38.9306 74.9974 39.9087 75.8719 41.0635 76.4436C42.2184 77.0153 43.5068 77.2629 44.7913 77.16L94.6913 72.92",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8413 26.86L87.8413 21.94C88.4127 21.891 88.9877 21.9714 89.5238 22.175C90.0599 22.3786 90.5432 22.7003 90.938 23.1162C91.3328 23.5321 91.6289 24.0316 91.8043 24.5776C91.9797 25.1235 92.03 25.702 91.9513 26.27L88.0213 54.64C87.902 55.4912 87.4998 56.2775 86.8795 56.8724C86.2591 57.4673 85.4567 57.8363 84.6013 57.92L40.4413 62.23L29.8413 26.86Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3414 86.72C52.9426 86.72 55.0514 84.6113 55.0514 82.01C55.0514 79.4088 52.9426 77.3 50.3414 77.3C47.7401 77.3 45.6313 79.4088 45.6313 82.01C45.6313 84.6113 47.7401 86.72 50.3414 86.72Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1412 83.94C85.7424 83.94 87.8512 81.8313 87.8512 79.23C87.8512 76.6288 85.7424 74.52 83.1412 74.52C80.5399 74.52 78.4312 76.6288 78.4312 79.23C78.4312 81.8313 80.5399 83.94 83.1412 83.94Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8658 14.404L5.60986 15.4439C4.54776 15.5341 3.75982 16.4681 3.84994 17.5302C3.94006 18.5923 4.87412 19.3802 5.93621 19.2901L18.1922 18.2502C19.2543 18.1601 20.0422 17.226 19.9521 16.1639C19.862 15.1018 18.9279 14.3139 17.8658 14.404Z",
    fill: "#3B0069"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2612 48.77C54.5004 46.9449 55.3563 45.2565 56.6869 43.9847C58.0175 42.7129 59.743 41.9342 61.577 41.7778C63.411 41.6213 65.2433 42.0966 66.7701 43.1246C68.297 44.1527 69.4264 45.6718 69.9712 47.43",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1012 37.98C70.7198 37.98 71.2212 37.4786 71.2212 36.86C71.2212 36.2415 70.7198 35.74 70.1012 35.74C69.4826 35.74 68.9812 36.2415 68.9812 36.86C68.9812 37.4786 69.4826 37.98 70.1012 37.98Z",
    fill: "#3B0069"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3512 39.48C52.9698 39.48 53.4712 38.9786 53.4712 38.36C53.4712 37.7415 52.9698 37.24 52.3512 37.24C51.7326 37.24 51.2312 37.7415 51.2312 38.36C51.2312 38.9786 51.7326 39.48 52.3512 39.48Z",
    fill: "#3B0069"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8013 80.62V84.93",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6514 82.77H22.9514",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5112 0.5V4.8",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3613 2.65002H91.6613",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6013 13.35V17.65",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4412 15.5H40.7512",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.241 29.16C100.805 29.16 101.261 28.7033 101.261 28.14C101.261 27.5767 100.805 27.12 100.241 27.12C99.6779 27.12 99.2212 27.5767 99.2212 28.14C99.2212 28.7033 99.6779 29.16 100.241 29.16Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1214 19.99C62.6626 19.99 63.1014 19.5512 63.1014 19.01C63.1014 18.4688 62.6626 18.03 62.1214 18.03C61.5801 18.03 61.1414 18.4688 61.1414 19.01C61.1414 19.5512 61.5801 19.99 62.1214 19.99Z",
    fill: "#3B0069",
    fillOpacity: 0.39
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7012 91.11C69.2424 91.11 69.6812 90.6713 69.6812 90.13C69.6812 89.5888 69.2424 89.15 68.7012 89.15C68.16 89.15 67.7212 89.5888 67.7212 90.13C67.7212 90.6713 68.16 91.11 68.7012 91.11Z",
    fill: "#3B0069",
    fillOpacity: 0.39
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorEmpty);
export default __webpack_public_path__ + "static/media/VendorEmpty.946dbe66773ffdaa7d949e7a88fcf79b.svg";
export { ForwardRef as ReactComponent };